export const ButtonVariableNames = {
  'wst-button-primary-background-color': 'wst-button-primary-background-color',
  'wst-button-primary-border-left-color': 'wst-button-primary-border-left-color',
  'wst-button-primary-border-right-color': 'wst-button-primary-border-right-color',
  'wst-button-primary-border-top-color': 'wst-button-primary-border-top-color',
  'wst-button-primary-border-bottom-color': 'wst-button-primary-border-bottom-color',
  'wst-button-primary-color': 'wst-button-primary-color',
  'wst-button-primary-font': 'wst-button-primary-font',
  'wst-button-primary-font-family': 'wst-button-primary-font-family',
  'wst-button-primary-font-size': 'wst-button-primary-font-size',
  'wst-button-primary-font-style': 'wst-button-primary-font-style',
  'wst-button-primary-font-weight': 'wst-button-primary-font-weight',
  'wst-button-primary-text-decoration': 'wst-button-primary-text-decoration',
  'wst-button-primary-text-transform': 'wst-button-primary-text-transform',
  'wst-button-primary-letter-spacing': 'wst-button-primary-letter-spacing',
  'wst-button-primary-line-height': 'wst-button-primary-line-height',
  'wst-button-primary-text-highlight': 'wst-button-primary-text-highlight',
  'wst-button-primary-text-outline': 'wst-button-primary-text-outline',
  'wst-button-primary-text-shadow': 'wst-button-primary-text-shadow',
  'wst-button-primary-box-shadow': 'wst-button-primary-box-shadow',
  'wst-button-primary-border-left-width': 'wst-button-primary-border-left-width',
  'wst-button-primary-border-right-width': 'wst-button-primary-border-right-width',
  'wst-button-primary-border-top-width': 'wst-button-primary-border-top-width',
  'wst-button-primary-border-bottom-width': 'wst-button-primary-border-bottom-width',
  'wst-button-primary-border-left-style': 'wst-button-primary-border-left-style',
  'wst-button-primary-border-right-style': 'wst-button-primary-border-right-style',
  'wst-button-primary-border-top-style': 'wst-button-primary-border-top-style',
  'wst-button-primary-border-bottom-style': 'wst-button-primary-border-bottom-style',
  'wst-button-primary-padding-bottom': 'wst-button-primary-padding-bottom',
  'wst-button-primary-padding-top': 'wst-button-primary-padding-top',
  'wst-button-primary-padding-left': 'wst-button-primary-padding-left',
  'wst-button-primary-padding-right': 'wst-button-primary-padding-right',
  'wst-button-primary-border-top-left-radius': 'wst-button-primary-border-top-left-radius',
  'wst-button-primary-border-top-right-radius': 'wst-button-primary-border-top-right-radius',
  'wst-button-primary-border-bottom-left-radius': 'wst-button-primary-border-bottom-left-radius',
  'wst-button-primary-border-bottom-right-radius': 'wst-button-primary-border-bottom-right-radius',
  'wst-button-primary-column-gap': 'wst-button-primary-column-gap',
  'wst-button-primary-row-gap': 'wst-button-primary-row-gap',
  'wst-button-secondary-background-color': 'wst-button-secondary-background-color',
  'wst-button-secondary-border-left-color': 'wst-button-secondary-border-left-color',
  'wst-button-secondary-border-right-color': 'wst-button-secondary-border-right-color',
  'wst-button-secondary-border-top-color': 'wst-button-secondary-border-top-color',
  'wst-button-secondary-border-bottom-color': 'wst-button-secondary-border-bottom-color',
  'wst-button-secondary-color': 'wst-button-secondary-color',
  'wst-button-secondary-font': 'wst-button-secondary-font',
  'wst-button-secondary-font-family': 'wst-button-secondary-font-family',
  'wst-button-secondary-font-size': 'wst-button-secondary-font-size',
  'wst-button-secondary-font-style': 'wst-button-secondary-font-style',
  'wst-button-secondary-font-weight': 'wst-button-secondary-font-weight',
  'wst-button-secondary-text-decoration': 'wst-button-secondary-text-decoration',
  'wst-button-secondary-text-transform': 'wst-button-secondary-text-transform',
  'wst-button-secondary-letter-spacing': 'wst-button-secondary-letter-spacing',
  'wst-button-secondary-line-height': 'wst-button-secondary-line-height',
  'wst-button-secondary-text-highlight': 'wst-button-secondary-text-highlight',
  'wst-button-secondary-text-outline': 'wst-button-secondary-text-outline',
  'wst-button-secondary-text-shadow': 'wst-button-secondary-text-shadow',
  'wst-button-secondary-box-shadow': 'wst-button-secondary-box-shadow',
  'wst-button-secondary-border-left-width': 'wst-button-secondary-border-left-width',
  'wst-button-secondary-border-right-width': 'wst-button-secondary-border-right-width',
  'wst-button-secondary-border-top-width': 'wst-button-secondary-border-top-width',
  'wst-button-secondary-border-bottom-width': 'wst-button-secondary-border-bottom-width',
  'wst-button-secondary-border-left-style': 'wst-button-secondary-border-left-style',
  'wst-button-secondary-border-right-style': 'wst-button-secondary-border-right-style',
  'wst-button-secondary-border-top-style': 'wst-button-secondary-border-top-style',
  'wst-button-secondary-border-bottom-style': 'wst-button-secondary-border-bottom-style',
  'wst-button-secondary-padding-bottom': 'wst-button-secondary-padding-bottom',
  'wst-button-secondary-padding-top': 'wst-button-secondary-padding-top',
  'wst-button-secondary-padding-left': 'wst-button-secondary-padding-left',
  'wst-button-secondary-padding-right': 'wst-button-secondary-padding-right',
  'wst-button-secondary-border-top-left-radius': 'wst-button-secondary-border-top-left-radius',
  'wst-button-secondary-border-top-right-radius': 'wst-button-secondary-border-top-right-radius',
  'wst-button-secondary-border-bottom-left-radius': 'wst-button-secondary-border-bottom-left-radius',
  'wst-button-secondary-border-bottom-right-radius': 'wst-button-secondary-border-bottom-right-radius',
  'wst-button-secondary-column-gap': 'wst-button-secondary-column-gap',
  'wst-button-secondary-row-gap': 'wst-button-secondary-row-gap',
  'wst-button-tertiary-background-color': 'wst-button-tertiary-background-color',
  'wst-button-tertiary-border-left-color': 'wst-button-tertiary-border-left-color',
  'wst-button-tertiary-border-right-color': 'wst-button-tertiary-border-right-color',
  'wst-button-tertiary-border-top-color': 'wst-button-tertiary-border-top-color',
  'wst-button-tertiary-border-bottom-color': 'wst-button-tertiary-border-bottom-color',
  'wst-button-tertiary-color': 'wst-button-tertiary-color',
  'wst-button-tertiary-font': 'wst-button-tertiary-font',
  'wst-button-tertiary-font-family': 'wst-button-tertiary-font-family',
  'wst-button-tertiary-font-size': 'wst-button-tertiary-font-size',
  'wst-button-tertiary-font-style': 'wst-button-tertiary-font-style',
  'wst-button-tertiary-font-weight': 'wst-button-tertiary-font-weight',
  'wst-button-tertiary-text-decoration': 'wst-button-tertiary-text-decoration',
  'wst-button-tertiary-text-transform': 'wst-button-tertiary-text-transform',
  'wst-button-tertiary-letter-spacing': 'wst-button-tertiary-letter-spacing',
  'wst-button-tertiary-line-height': 'wst-button-tertiary-line-height',
  'wst-button-tertiary-text-highlight': 'wst-button-tertiary-text-highlight',
  'wst-button-tertiary-text-outline': 'wst-button-tertiary-text-outline',
  'wst-button-tertiary-text-shadow': 'wst-button-tertiary-text-shadow',
  'wst-button-tertiary-box-shadow': 'wst-button-tertiary-box-shadow',
  'wst-button-tertiary-border-left-width': 'wst-button-tertiary-border-left-width',
  'wst-button-tertiary-border-right-width': 'wst-button-tertiary-border-right-width',
  'wst-button-tertiary-border-top-width': 'wst-button-tertiary-border-top-width',
  'wst-button-tertiary-border-bottom-width': 'wst-button-tertiary-border-bottom-width',
  'wst-button-tertiary-border-left-style': 'wst-button-tertiary-border-left-style',
  'wst-button-tertiary-border-right-style': 'wst-button-tertiary-border-right-style',
  'wst-button-tertiary-border-top-style': 'wst-button-tertiary-border-top-style',
  'wst-button-tertiary-border-bottom-style': 'wst-button-tertiary-border-bottom-style',
  'wst-button-tertiary-padding-bottom': 'wst-button-tertiary-padding-bottom',
  'wst-button-tertiary-padding-top': 'wst-button-tertiary-padding-top',
  'wst-button-tertiary-padding-left': 'wst-button-tertiary-padding-left',
  'wst-button-tertiary-padding-right': 'wst-button-tertiary-padding-right',
  'wst-button-tertiary-border-top-left-radius': 'wst-button-tertiary-border-top-left-radius',
  'wst-button-tertiary-border-top-right-radius': 'wst-button-tertiary-border-top-right-radius',
  'wst-button-tertiary-border-bottom-left-radius': 'wst-button-tertiary-border-bottom-left-radius',
  'wst-button-tertiary-border-bottom-right-radius': 'wst-button-tertiary-border-bottom-right-radius',
  'wst-button-tertiary-column-gap': 'wst-button-tertiary-column-gap',
  'wst-button-tertiary-row-gap': 'wst-button-tertiary-row-gap'
};
//# sourceMappingURL=button.js.map